/* eslint-disable */
// @ts-nocheck
/**
 * RTM Frontend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */

export const AgentAttendanceLabel = {
  Late: 'LATE',
  LeftEarly: 'LEFT_EARLY',
  Absent: 'ABSENT',
  Overtime: 'OVERTIME',
  LowAdherence: 'LOW_ADHERENCE',
} as const

export type AgentAttendanceLabel =
  (typeof AgentAttendanceLabel)[keyof typeof AgentAttendanceLabel]
